var render = function render(){var _vm=this,_c=_vm._self._c;return _c('v-avatar',{attrs:{"size":_vm.size}},[_c('img',{attrs:{"src":_vm.avatar,"alt":""}})])
}
var staticRenderFns = []

export { render, staticRenderFns }